<template>
  <history-visit filter="all"></history-visit>
</template>

<script>
import historyVisit from "@/components/views/history/history-visits.view.vue";

export default {
  components: {
    historyVisit
  }
};
</script>
